/**
 * FN-040 표기 통화 — 정적 설정 (design meStats.ts 에서 분리. 더미 데이터가 아니다).
 *
 * 벤치마크(MonPrice)는 USD 기본에 수십 종을 나열하지만, Peeka 는 **KRW 가 기본**이고
 * (PRD §3.2·§5.7) 시세는 항상 원화 + 원본 통화 병기다. 그래서 목록도 원본 통화로
 * 실제 쓰이는 3종을 앞에 두고, 나머지는 참고용으로 붙인다 — 고를 수 있는 통화가
 * 시세 소스와 무관하게 수십 개면 "이 숫자가 어디서 왔나"가 흐려진다.
 */
export interface CurrencyOption {
  code: string;
  symbol: string;
  /**
   * 통화명 i18n 키 (me ns). 검색은 코드 + 이름으로 한다
   * (SC-017 · FN-040, design 2026-08-28) — 이름이 언어를 타므로 키만 둔다.
   */
  nameKey: string;
  /** 시세 원본 통화(한국판 KRW · 영문판 USD · 일본판 JPY)인지 */
  isSource: boolean;
}

export const CURRENCIES: CurrencyOption[] = [
  { code: "KRW", symbol: "₩", nameKey: "display.currencyName.KRW", isSource: true },
  { code: "USD", symbol: "$", nameKey: "display.currencyName.USD", isSource: true },
  { code: "JPY", symbol: "¥", nameKey: "display.currencyName.JPY", isSource: true },
  { code: "EUR", symbol: "€", nameKey: "display.currencyName.EUR", isSource: false },
  { code: "GBP", symbol: "£", nameKey: "display.currencyName.GBP", isSource: false },
  { code: "CNY", symbol: "¥", nameKey: "display.currencyName.CNY", isSource: false },
  { code: "TWD", symbol: "NT$", nameKey: "display.currencyName.TWD", isSource: false },
  { code: "HKD", symbol: "HK$", nameKey: "display.currencyName.HKD", isSource: false },
  { code: "SGD", symbol: "S$", nameKey: "display.currencyName.SGD", isSource: false },
  { code: "AUD", symbol: "A$", nameKey: "display.currencyName.AUD", isSource: false },
  { code: "CAD", symbol: "C$", nameKey: "display.currencyName.CAD", isSource: false },
];

export const DEFAULT_CURRENCY = "KRW";
